import type * as Y from 'yjs';

import {
  type BasicYArray,
  type DisposableElement,
  type WrappedYType
} from './helpers/types.ts';
import { YUniqueArray } from './helpers/y-unique-array.ts';

export class YViewsArray implements DisposableElement, WrappedYType {
  private readonly views: YUniqueArray<string>;

  constructor(array: BasicYArray<string>) {
    this.views = new YUniqueArray(array);
  }

  public toArray(): string[] {
    return this.views.toArray();
  }

  public delete(...values: string[]): void {
    this.views.delete(...values);
  }

  addBefore(value: string[], before: string): void {
    this.views.addBefore(value, before);
  }

  addEnd(value: string): void {
    this.views.addEnd(value);
  }

  unwrap(): Y.AbstractType<string> | undefined {
    return this.views.unwrap();
  }

  dispose(): void {
    this.views.dispose();
  }

  get length(): number {
    return this.views.length;
  }
}
